import { PLAN_TYPES } from "../constants/personaldata";
import { isEnableProperty } from "../libs/helpers/object";

const defaultPlantType = !isEnableProperty(process.env.REACT_APP_ENABLE_FULL_PLAN)
    ? PLAN_TYPES.CUSTOM
    : null;
export class PersonalDataInfo {
    constructor({
        clientType = null,
        planType = defaultPlantType,
        whichEnsure = null,
        housingType = null,
    } = {}) {
        this.clientType = clientType;
        this.planType = planType;
        this.whichEnsure = whichEnsure;
        this.housingType = housingType;
    }
}
